<template>
    <div>
        <div class="catalog-categories__collapse-item"
             :class="{'active': filter.state.active_category === category.url}">

            <span @click="toggleShowChildrenCategory(category.url)"
                  :class="{'active': active}"
                  class="icon-category">
            </span>

<!--            <div class="h6" @click="getProductCategory(category.url)">{{category.name}}</div>-->

            <router-link :to="category.url" class="catalog-categories__collapse-item final-item"
                         :class="{'active': filter.state.active_category === category.url}">
                <div class="h6">{{category.name}}</div>
            </router-link>

            <!--
            <div v-if="category.level_category != 0" class="h6" @click="getProductCategory(category.url)">{{category.name}}</div>
            <div v-else class="h6" @click="toggleShowChildrenCategory(category.url)">{{category.name}}</div>
            -->
        </div>

        <div class="catalog-categories__group pl-20">
            <catalog-category-card v-if="subcategory" v-for="(item, i) in subcategory" :key="i"
                                   :category="item"></catalog-category-card>


            <div v-if="products">
                <router-link :to="product.url" v-for="(product, p) in products" :key="p"
                             class="catalog-categories__collapse-item final-item"
                             :class="{'active': filter.state.active_category === product.url}">
                    <div class="h6">{{product.name}}</div>
                </router-link>
            </div>
        </div>

    </div>
</template>

<script>
    import filter from '../../services/filter';

    export default {
        props: ['category'],
        data() {
            return {
                subcategory: null,
                products: null,
                active: false,

                filter: filter,

                padding: 0
            }
        },

        watch: {
            $route() {
                if (this.$route.name === 'pages-catalog-category' || this.$route.name === 'pages-catalog-category-subcategory') this.loadCategory();
                else if (this.$route.name === 'pages-catalog' || this.$route.name === 'pages-catalog-new') this.reset();
                else if (this.$route.name === 'pages-catalog-show') this.getCategoryFromProductPage();
                else {
                    this.filter.state.active_category = null;
                    this.reset();
                }
            }
        },

        mounted() {
            if (this.$route.name === 'pages-catalog-category' || this.$route.name === 'pages-catalog-category-subcategory') this.loadCategory();
            if (this.$route.name === 'pages-catalog-show') this.getCategoryFromProductPage();
        },


        methods: {
            getProductCategory(url) {
                if (this.$route.path !== url) {
                    this.$router.push({path: url});
                    this.getBreadcrumb(this.category.parents, this.category);
                    this.scrollTop();
                }

            },

            toggleShowChildrenCategory(request) {
                if (this.active) {
                    this.reset();
                    return;
                }
                if (!this.active) {
                    this.getChildrenCategory(request);
                }
            },

            getChildrenCategory(request) {
                let url = '/api/menu/sub-categories';
                let params = {
                    url: request
                };
                axios.post(url, params)
                    .then(response => {
                        this.subcategory = response.data.subCategories;
                        if (response.data.products) this.products = response.data.products;
                    });
                this.active = true;
            },


            loadCategory() {
                /* проверяем, если находимся в главной категории*/
                if (this.category.slug == this.$route.params.category) {
                    this.getChildrenCategory(this.category.url);
                    if (!this.$route.params.pathMatch) {
                        console.log('categoryCard1-1');
                        this.getProducts(this.category);
                    }

                    this.getBreadcrumb(null, this.category);
                } else if (this.$route.path === this.category.url) {}
                else this.reset();

                if (this.$route.params.pathMatch) {
                    let categories = this.$route.params.pathMatch;
                    categories = categories.split('/');

                    let request_url = [];
                    let i = '/catalog/category/' + this.$route.params.category;
                    categories.forEach(item => {
                        i = i + '/' + item;
                        request_url.push(i)
                    });

                    let count = 0;
                    request_url.forEach(item => {
                        count++;
                        if (item === this.category.url) {
                            this.active = true;
                            this.getChildrenCategory(item);
                            if (request_url.length == count) {
                                console.log('categoryCard1-2');
                                this.getProducts(this.category);
                            }
                            this.getBreadcrumb(this.category.parents, this.category);
                        }
                    });


                }
            },

            getProducts(category) {
                this.filter.filter.url = category.url;
                this.filter.state.active_category = category.url;
                this.filter.getProducts();
            },

            getBreadcrumb(parents, item) {
                this.filter.getBreadcrumb(parents, item)
            },

            getCategoryFromProductPage() {
                let category = this.filter.state.product_category;
                if (category.mainCategory.url === this.category.url) this.getChildrenCategory(this.category.url);
                if (category.level2 && category.level2.url === this.category.url) this.getChildrenCategory(this.category.url);
                if (category.level3 && category.level3.url === this.category.url) this.getChildrenCategory(this.category.url);
                if (category.level4 && category.level4.url === this.category.url) this.getChildrenCategory(this.category.url);
                if (category.level5 && category.level5.url === this.category.url) this.getChildrenCategory(this.category.url);
                this.filter.state.active_category = this.$route.path;

            },

            scrollTop() {
                document.getElementById('app').scrollIntoView({behavior: "smooth"})
            },

            reset() {
                this.active = false;
                this.subcategory = null;
                this.products = null;
            }
        }
    }
</script>
